import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { Project } from '@app/models/project';
import { Observable, of } from 'rxjs';
import { ProjectService } from '@app/services/project.service';
import { Environment } from '@environments/interface.environment';
import { CUSTOMERENVIRONMENT } from '@app/common/app-tokens';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { concatMap, tap } from 'rxjs/operators';

@Component({
  selector: 'app-edit-project-infoclass-form',
  templateUrl: './edit-project-infoclass-form.component.html',
  styleUrls: ['./edit-project-infoclass-form.component.scss']
})
export class EditProjectInfoclassFormComponent implements OnInit {

  pdpProjectId = this.route.snapshot.params['pdpProjectId'];
  project$: Observable<Project>;
  project: Project;
  errorMessage: string;
  viewState = 'form';

  selectedInfoClass: number;
  formGroupInfoclass: FormGroup;

  constructor(@Inject(CUSTOMERENVIRONMENT) private environment: Environment,
    private _formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private projectService: ProjectService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {

    this.formGroupInfoclass = this._formBuilder.group({
      InfoClass: new FormControl({})
    });

    this.project$ = this.projectService.getProject(this.pdpProjectId);
    this.project$.subscribe(p => {
      this.project = p;
      this.selectedInfoClass = p.InfoClass;
      this.changeDetectorRef.detectChanges();
      return p;
    });

  }

  setInfoClassCssClass(selected: number): string {
    return this.selectedInfoClass === selected ? 'infoclass-block infoclass-block-selected' : 'infoclass-block';
  }

  updateProject() {
    this.viewState = 'working';

    var templateToApply = '';

    if (this.project.AppliedSiteTemplates !== null) { // if null this is assumed to be project connected to an existing o365 group, in which case we do not apply templates
      // 0/1 -> Public (K0/K1)
      // 2/3 -> Private (K2/K3)
      if (this.project.InfoClass <= 1 && this.selectedInfoClass >= 2) {
        templateToApply = "MakePrivate.xml";
      }
      if (this.project.InfoClass >= 2 && this.selectedInfoClass <= 1) {
        templateToApply = "MakePublic.xml";
      }
    }

    this.project.InfoClass = this.selectedInfoClass;
    /*
    const req = this.projectService.updateProject(this.project);

    req.subscribe(result => {
      this.viewState = 'ready';
    },
      err => {
        console.log(err);
        this.errorMessage = err.message + ': ' + err.error;
        this.viewState = 'error';
        this.changeDetectorRef.detectChanges();
      });
    */

    this.projectService.updateProject(this.project)
      .pipe(
        concatMap(() => {
          console.log("Project updated");
          if (templateToApply !== "") {
            console.log("Template to Apply: " + templateToApply);
            return this.projectService.applyTemplate(this.project.PdpProjectId, templateToApply);
          } else {
            console.log("No template to apply...");
            return of(true);
          }
        }),
        tap(() => {
          console.log("All done");
          this.viewState = 'ready';
        })
      ).subscribe(() => { },
        err => {
          console.log(err);
          this.errorMessage = err.message + ': ' + err.error;
          this.viewState = 'error';
          this.changeDetectorRef.detectChanges();
        }
      )

  }
}
